import { LinearGradient } from 'expo-linear-gradient'
import React, { useEffect, useRef } from 'react'
import { Animated, Platform, ViewStyle } from 'react-native'
import { YStack } from 'tamagui'

export type SkeletonRowProps = {
  height?: number
  borderRadius?: number
  backgroundColor?: string
  indentPx?: number
  style?: ViewStyle
}

export const SkeletonRow: React.FC<SkeletonRowProps> = ({
  height = 44,
  borderRadius = 12,
  backgroundColor = '#F9F7F4',
  indentPx = 0,
  style,
}) => {
  const v = useRef(new Animated.Value(0)).current
  useEffect(() => {
    const loop = Animated.loop(
      Animated.timing(v, {
        toValue: 1,
        duration: 1300,
        useNativeDriver: Platform.OS !== 'web',
      }),
      { resetBeforeIteration: true }
    )
    loop.start()
    return () => loop.stop()
  }, [v])

  const translateX = v.interpolate({ inputRange: [0, 1], outputRange: [-180, 360] })

  return (
    <YStack
      h={height}
      br={borderRadius}
      overflow="hidden"
      bg={backgroundColor}
      my={6}
      style={[{ marginLeft: indentPx }, style]}
    >
      <Animated.View style={{ position: 'absolute', top: 0, bottom: 0, width: 150, transform: [{ translateX }] }}>
        <LinearGradient
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          colors={[ 'rgba(255,255,255,0.0)', 'rgba(255,255,255,0.5)', 'rgba(255,255,255,0.0)' ]}
          style={{ flex: 1 }}
        />
      </Animated.View>
    </YStack>
  )
}


